<section class="why-tile-store-section">
  <div class="container">
    <div class="section-header">
      <div class="section-badge">WHY CHOOSE US test</div>
      <h2 class="tile-heading">Union Fire Protection?</h2>
      <p class="tile-intro">
       Choosing Union Fire Protection for your fire safety needs comes with a range of advantages designed to ensure reliable protection, professional service, and complete peace of mind. </p>
    </div>

   <div class="tile-benefits-grid">
  <div class="benefit-card">
    <div class="card-icon">
      <i class='bx bx-check-shield'></i>
    </div>
    <h3>High-Quality Fire Safety Systems</h3>
    <p>We provide top-grade fire protection systems sourced from trusted manufacturers, ensuring reliability, durability, and full safety compliance.</p>
  </div>

  <div class="benefit-card">
    <div class="card-icon">
      <i class='bx bx-grid-alt'></i>
    </div>
    <h3>Complete Fire Protection Solutions</h3>
    <p>We offer a wide range of services including fire alarm systems, fire fighting systems, emergency lighting, and other life safety solutions.</p>
  </div>

  <div class="benefit-card">
    <div class="card-icon">
      <i class='bx bx-user-voice'></i>
    </div>
    <h3>Expert Engineering Team</h3>
    <p>Our experienced engineers provide professional guidance to design and implement the most effective fire safety systems for your project.</p>
  </div>

  <div class="benefit-card">
    <div class="card-icon">
      <i class='bx bx-cog'></i>
    </div>
    <h3>Customized Solutions</h3>
    <p>We tailor fire protection systems based on your specific requirements, ensuring maximum safety and compliance with Qatar standards.</p>
  </div>

  <div class="benefit-card">
    <div class="card-icon">
      <i class='bx bx-tag'></i>
    </div>
    <h3>Cost-Effective Services</h3>
    <p>We deliver high-quality fire safety solutions at competitive pricing, providing excellent value without compromising on safety.</p>
  </div>

  <div class="benefit-card">
    <div class="card-icon">
      <i class='bx bx-support'></i>
    </div>
    <h3>Reliable Maintenance & Support</h3>
    <p>We provide dependable after-sales support and maintenance services to ensure your fire protection systems remain fully operational at all times.</p>
  </div>
</div>
  </div>
</section>
